import '../../css/base.css';

const LivingRoom = () => {

  return (
    <div>
     <h2 className="your-stay-section-heading">Living Room</h2>
      <p className="your-stay-text">Lovely and cosy with a log and coal burning fire. You will find the fire
                                    set on arrival. Additional logs, kindling and coal can be purchased locally
                                    at the shop in Glenelg or the garage in either Shiel Bridge or Inverinate.
                                    <strong> Please always use the fireguard as sparks do travel, especially if you
                                    have small children and pets</strong>.
      </p>                                            
      <p className="your-stay-text">TV with Sky freeview, Apple TV with netflix and a DVD player.
      </p>
      <p className="your-stay-text">The cottage phone number is 01559 235034.
                                    Please note mobile phone coverage is patchy in the area.
      </p>       
    </div>
  );
}

export default LivingRoom;